module.exports = __webpack_public_path__ + "img/vue2-toebox_lavande.d1b42919.png";